/* eslint-disable @nx/enforce-module-boundaries */
import { AddCircle } from '@mybridge/icons';
import { Button, HStack, Link, Tab, TabList, Tabs } from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { forwardRef } from 'react';
import { isMobile } from 'react-device-detect';
export const JobsListingTabs = forwardRef(({ active, ...props }, ref) => {
  const { t } = useTranslator();
  return (
    <HStack
      justifyContent="space-between"
      w="100%"
      // borderBottom="1px solid #ddd"
    >
      <Tabs
        defaultIndex={active}
        {...props}
        border="none"
        variant="myBridgeVariant"
      >
        <HStack>
          <Link
            as={Tab}
            fontWeight="600"
            fontSize={["14px" , '16px']}
            color="#65676B"
            href="/jobs/suggested"
            _selected={{ fontWeight: '600', color: 'brandPrimary.500' }}
          >
            {t('jobs.suggestedJobs') || "Suggested Jobs"}
          </Link>
          <Link
            as={Tab}
            fontWeight="600"
            fontSize={["14px" , '16px']}
            href="/jobs/my"
            color="#65676B"
            _selected={{ fontWeight: '600', color: 'brandPrimary.500' }}
          >
            {t('jobs.myJobs') || "My Jobs"}
          </Link>
          {/* <Link
            as={Tab}
            fontWeight="600"
            href="/jobs/my-job-posts"
            color="#65676B"
            _selected={{ fontWeight: '600', color: 'brandPrimary.500' }}
          >
            My Posted Jobs
          </Link> */}
        </HStack>
      </Tabs>

      <Link href="/page/jobs/create">
        <Button
          variant="transparent"
          fontSize={["14px" , '16px']}
          leftIcon={<AddCircle color="#65676B" />}
          color="#65676B"
        >
          {t('pageJobs.postJob') || "Post Job"}
        </Button>
      </Link>
    </HStack>
  );
});
